module.exports = __webpack_public_path__ + "static/media/livvie_blue.4315ea6d.png";